import React, { Component } from 'react'
import Script from 'react-load-script'
import Loader from 'react-loader-spinner'
import { LOAN_ALL_MAPPED_DATA_KEY, mapLegacyLoanData, parseLoanAllData } from './loanMapping'

class TpoConnectContainer extends Component {
    state = {
      infoText: 'Syncing with Reggora... ',
      spinnerVisibility: true,
      tpoScriptUrl: 'https://' + this.props.match.params.id + '.encompasstpoconnect.com/scripts/elli-ssf-guest.js',
    }

    render() {
      return <div>
            <h1> {this.state.infoText}</h1>
            {this.state.spinnerVisibility
              ? <Loader
                    type="Puff"
                    color="#00BFFF"
                    height={100}
                    width={100}
                />
              : null
            }
            <Script
                url={this.state.tpoScriptUrl}
                onCreate={this.handleScriptCreate.bind(this)}
                onError={this.handleScriptError.bind(this)}
                onLoad={this.handleScriptLoad.bind(this)}
            />
        </div>
    }

    handleScriptCreate() {
      this.setState({ scriptLoaded: false })
    }

    handleScriptError() {
      this.setState({ scriptError: true })
    }

    async handleScriptLoad() {
      this.setState({ scriptLoaded: true })
      await window.elli.script.guest.create()
      const tpoApplication = await window.elli.script.getObject('tpoApplication')
      // if (this.props.match.params.id) {
      //     try {
      //         let authCode = await tpoApplication.createAuthCode("Basic "+btoa('3c5hwwa8'))
      //         console.log(authCode.toString())
      //     } catch (error) {
      //         console.log(error.toString())
      //     }
      // }
      const userData = await tpoApplication.getUserData()
      const loanData = await tpoApplication.getLoanData()

      if (process.env.REACT_APP_TPO_ENV !== 'production') {
        console.log(JSON.stringify(loanData))
      }

      let tpo_api_url = 'https://9250-216-98-10-35.ngrok.io/v1/tpo/tpo_connect/loan_mapping' // Set ngrok here for local testing
      if (process.env.REACT_APP_TPO_ENV === 'development') {
        tpo_api_url = 'https://dev-service.reggora.com/v1/tpo/tpo_connect/loan_mapping'
      } else if (process.env.REACT_APP_TPO_ENV === 'staging') {
        tpo_api_url = 'https://staging-service.reggora.com/v1/tpo/tpo_connect/loan_mapping'
      } else if (process.env.REACT_APP_TPO_ENV === 'production') {
        tpo_api_url = 'https://prod-service.reggora.com/v1/tpo/tpo_connect/loan_mapping'
      }

      if (JSON.stringify(loanData) === '{}') {
        this.setState({
          infoText: 'Unable to retrieve loan data, please select loan again.',
          spinnerVisibility: false,
        })
        return this.state.infoText
      }

      try {
        const response = await fetch(tpo_api_url, {
          headers: new Headers({
            Authorization: 'Basic ' + btoa('username:password'),
            'Content-type': 'application/json',
          }),
          method: 'post',
          body: JSON.stringify({
            lender_secret: this.props.match.params.id,
            user: JSON.stringify(userData),
          }),
          crossDomain: true,
          mode: 'cors',
        })
        const data = await response.json()

        // Per-lender flag returned by the backend. When on, loan.all() data is parsed and sent alongside the
        // legacy mapping for comparison logging only; the legacy getLoanData mapping is still what gets imported.
        const useLoanAllApi = Boolean(data.use_loan_all_api)

        await this.performLoanMapping(
          loanData, data.field_mappings, data.lender_id, data.user_id, data.user_token, useLoanAllApi
        )
      } catch (error) {
        console.log(error)
      }
    }

    async getLoanAllMappedData(lenderMapping) {
      try {
        const loanObject = await window.elli.script.getObject('loan')
        const loanData = await loanObject.all()

        if (process.env.REACT_APP_TPO_ENV !== 'production') {
          console.log(JSON.stringify(loanData))
        }

        return parseLoanAllData(loanData, lenderMapping)
      } catch (error) {
        console.log(error)
        return null
      }
    }

    async performLoanMapping(tpoData, lenderMapping, lenderId, userId, user_token, useLoanAllApi = false) {
      let tpo_api_url = 'https://9250-216-98-10-35.ngrok.io/v1/tpo/tpo_connect/loan_link'
      if (process.env.REACT_APP_TPO_ENV === 'development') {
        tpo_api_url = 'https://dev-service.reggora.com/v1/tpo/tpo_connect/loan_link'
      } else if (process.env.REACT_APP_TPO_ENV === 'staging') {
        tpo_api_url = 'https://staging-service.reggora.com/v1/tpo/tpo_connect/loan_link'
      } else if (process.env.REACT_APP_TPO_ENV === 'production') {
        tpo_api_url = 'https://prod-service.reggora.com/v1/tpo/tpo_connect/loan_link'
      }

      const mapped_values = mapLegacyLoanData(tpoData, lenderMapping)

      if (useLoanAllApi) {
        const loanAllMappedData = await this.getLoanAllMappedData(lenderMapping)
        if (loanAllMappedData) {
          mapped_values[LOAN_ALL_MAPPED_DATA_KEY] = loanAllMappedData
        }
      }

      await fetch(tpo_api_url, {
        headers: new Headers({
          'Content-type': 'application/json',
          Authorization: 'Bearer ' + user_token,
        }),
        method: 'post',
        body: JSON.stringify({
          mapped_data: JSON.stringify(mapped_values),
          lender_id: lenderId,
          user_id: userId,
        }),
        crossDomain: true,
        mode: 'cors',
      })
        .then(response => response.json())
        .then(data => this.openUrl(data.loan_url))
        .catch(error => console.log(error))
    }

    async openUrl(url) {
      window.location.replace(url)
    }
}

export default TpoConnectContainer
